<template>
  <v-row justify="center">
    <v-dialog
      :value="active"
      @click:outside="closeDialog"
      scrollable
      max-width="500"
      persistent
    >
      <ValidationObserver ref="obs" v-slot="{ handleSubmit }">
        <v-card>
          <v-progress-linear
            v-if="isLoading"
            indeterminate
            color="primary"
            rounded
            height="6"
          ></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Descargar datos {{ surveyId }}
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text style="max-height: 350px">
              <v-form>
                <v-row dense justify="center">
                  <v-col cols="12">
                    <!-- <p class="grey--text caption pb-3">
                                            <v-icon small left color="blue-grey"
                                                >mdi-information</v-icon
                                            >Seleccione un rango de fecha para
                                            la búsqueda.
                                        </p> -->

                    <v-menu
                      ref="dateRangeMenu"
                      v-model="dateRangeMenu"
                      :close-on-content-click="false"
                      :return-value.sync="dates"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <ValidationProvider
                          rules="required"
                          name="Fechas"
                          v-slot="{ errors }"
                        >
                          <v-text-field
                            v-model="dates"
                            required
                            filled
                            rounded
                            class="rounded-small"
                            label="Rango de fecha"
                            :error-messages="errors"
                            readonly
                            v-on="on"
                          ></v-text-field>
                        </ValidationProvider>
                      </template>
                      <v-date-picker
                        locale="es-us"
                        v-model="dates"
                        :max="new Date().toISOString().substr(0, 10)"
                        range
                        scrollable
                        no-title
                        color="primary"
                      >
                        <v-spacer></v-spacer>
                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            text
                            rounded
                            class="mr-1"
                            :color="hover ? 'error' : 'grey'"
                            @click="dateRangeMenu = false"
                          >
                            Cancelar
                          </v-btn>
                        </v-hover>

                        <v-hover v-slot:default="{ hover }">
                          <v-btn
                            rounded
                            :loading="isLoading"
                            :disabled="isLoading"
                            color="success"
                            :class="hover ? 'shadow-2' : 'shadow-4'"
                            class="px-8"
                            @click="$refs.dateRangeMenu.save(dates)"
                          >
                            ok
                          </v-btn>
                        </v-hover>
                      </v-date-picker>
                    </v-menu>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>
          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn
                text
                rounded
                class="mr-1"
                :color="hover ? 'error' : 'grey'"
                @click="closeDialog"
              >
                Cancelar
              </v-btn>
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="isLoading"
                :disabled="isLoading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="handleSubmit(submitForm)"
              >
                Descargar
              </v-btn>
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import { PbxHttpClient } from "@/services/httpclient";
import vuescroll from "vuescroll";
export default {
  components: { vuescroll },
  props: {
    active: {
      type: Boolean,
    },
    surveyId: { type: Number },
  },

  data() {
    return {
      isLoading: false,
      dateRangeMenu: false,
      dates: null,
    };
  },

  methods: {
    closeDialog() {
      this.$emit("dialog:close");
    },
    async submitForm() {
      this.isLoading = true;
      try {
        const [start, end] = this.dates;
        // const { data } = await PbxHttpClient.get(
        //   `/response_survey_export?survey_id=${this.surveyId}&start=${start}&end=${end}`
        // );
        // const url = window.URL.createObjectURL(new Blob([data]));
        // const link = document.createElement("a");
        // link.href = url;
        // link.setAttribute("download", `Listado de encuestas.xlsx`);
        // document.body.appendChild(link);
        // link.click();

        const res = await PbxHttpClient.get(
          `/response_survey_export?survey_id=${this.surveyId}&start=${start}&end=${end}`,
          {
            responseType: "blob",
          }
        );
        const url = window.URL.createObjectURL(new Blob([res.data]));
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute(
          "download",
          `Formulario.xlsx`
          // `Reporte resumido de ${this.agentName} - ${this.evaluationName}.xlsx`
        );
        document.body.appendChild(link);
        link.click();
      } catch (err) {
        if (err.response.data.error)
          this.$snotify.error(
            `No se pudo obtener los datos. ${err.response.data.error}`,
            "¡Error!"
          );

        // console.log(err);
      } finally {
        this.isLoading = false;
      }
    },
  },
};
</script>

<style></style>
